"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckAudioOutput = void 0;
var _FormLabel = require("../../FormLabel");
var _ReadinessCheckerAudioTest = require("../../ReadinessCheckerAudioTest");
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
/**
 * Component that allows users to test their audio output device.
 * Renders an audio test interface with a label and controls.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.audioOutputDevice - ID of the selected audio output device
 * @param {boolean} props.disabled - Whether the audio test control should be disabled
 * @returns {React.Element} Rendered component
 */
var CheckAudioOutput = exports.CheckAudioOutput = function CheckAudioOutput(_ref) {
  var audioOutputDevice = _ref.audioOutputDevice,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, {
    id: "test-audio-label",
    label: "Test audio",
    labelFor: "audioOutputTest",
    useAs: "span"
  }), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.ReadinessCheckerAudioTest, {
    audioDeviceId: audioOutputDevice,
    disabled: disabled
  }));
};
CheckAudioOutput.propTypes = {
  audioOutputDevice: _propTypes.string.isRequired,
  disabled: _propTypes.bool.isRequired
};